import { render, staticRenderFns } from "./discountsVerification.vue?vue&type=template&id=3b3be15c&scoped=true"
import script from "./discountsVerification.vue?vue&type=script&lang=js"
export * from "./discountsVerification.vue?vue&type=script&lang=js"
import style0 from "./discountsVerification.vue?vue&type=style&index=0&id=3b3be15c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3be15c",
  null
  
)

export default component.exports